import textFormatting from '../../text-formatting';
import view from '../../view';

const selectFromEnd = (anchorNode, anchorOffset) => {
  const liveDocument = view.accessors.getLiveDocument();
  const selection = textFormatting.accessors.getAdvancedSelection();
  const { focusOffset, focusNode } = selection;
  const range = liveDocument.createRange();

  try {
    range.setStart(anchorNode, anchorOffset);
    range.setEnd(focusNode, focusOffset);
  } catch (e) {
    // set collapsed selection and the end if something went wrong
    range.setStart(focusNode, focusOffset);
    range.setEnd(focusNode, focusOffset);
  }

  selection.removeAllRanges();
  selection.addRange(range);
  selection.refresh();
};

export default selectFromEnd;
